import TransportMenu from "./TransportMenu";
import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import { toast, ToastContainer } from "react-toastify";
import { NavLink, Link } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import { Form } from "react-bootstrap";
import MonthsDropDown from "../Shared/MonthsDropDown";
import YearsDropDown from "../Shared/YearsDropDown";
import { getMonthName } from "../General/Utility";
import csvDownload from "json-to-csv-export";
import BusrouteDropDown from "../Shared/BusrouteDropDown";

const RoutesReport = () => {
    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(
        localStorage.getItem("MemberType")
    );

    const [showFilters, setShowFilters] = useState(true);

    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [validated, setValidated] = useState(false);
    const [loaddata, setLoaddata] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [summary, setSummary] = useState({
        TransportStudents: 0,
        FeePostedStudents: 0,
        PaidStudents: 0,
        TotalPostedFee: 0,
        TotalReceiveableFee: 0,
        TotalReceivedAmount: 0,
        TotalPendingFee: 0,
        TotalConcessionAmount: 0,
    });

    const [Wing, setWing] = useState("");
    const [Section, setSection] = useState("");
    const [Session, setSession] = useState(localStorage.getItem("DefaultSession"));
    const [Class, setClass] = useState("");
    const [ReportMonth, setReportMonth] = useState(moment().format("M"));
    const [ReportYear, setReportYear] = useState(moment().format("YYYY"));
    const [RouteID, setRouteID] = useState(0);

    document.title = "Bus Routes Report";

    useEffect(() => {
        setLoading(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: pageNo,
            pageSize: pageSize,
            ReportYear: ReportYear,
            ReportMonth: ReportMonth,
            Wing_Id: Number(Wing) || 0,
            Class_Id: Number(Class) || 0,
            Section_Id: Number(Section) || 0,
            AccountLevel: RouteID,
        };

        var api_config = {
            method: "post",
            url: config.base_url + "/Reports/GetRoutesReport",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    setLedger(response.data.ListofRecords || []);
                    setTotalRecords(response.data.totalRecords || 0);
                    setSummary({
                        TransportStudents: response.data.TransportStudents || 0,
                        FeePostedStudents: response.data.FeePostedStudents || 0,
                        PaidStudents: response.data.PaidStudents || 0,
                        TotalPostedFee: response.data.TotalPostedFee || 0,
                        TotalReceiveableFee: response.data.TotalReceiveableFee || 0,
                        TotalReceivedAmount: response.data.TotalReceivedAmount || 0,
                        TotalPendingFee: response.data.TotalPendingFee || 0,
                        TotalConcessionAmount: response.data.TotalConcessionAmount || 0,
                    });
                } else {
                    setLedger([]);
                    setTotalRecords(0);
                    if (response.data.status_message) {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                }
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
            });
    }, [pageNo, pageSize, ReportYear, ReportMonth, Wing, Class, Section, RouteID]);

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            setPageNo(1);
            setReportYear(event.target.ReportYear.value);
            setReportMonth(event.target.ReportMonth.value);
            setWing(event.target.Wing.value || 0);
            setClass(event.target.Class.value || 0);
            setSection(event.target.Section.value || 0);
            setRouteID(event.target.Route.value || 0);
        }

        setValidated(true);
    };

    const handlePageChange = (page) => {
        setPageNo(page);
    };

    const buildCsvRows = (records) => {
        return records.map((item) => ({
            Serial_No: item.Status_Type_Id,
            Registration_No: item.Registration_No,
            Student_Name: item.Student_Name,
            Father_Name: item.Father_Name,
            Class: item.SelectedClass.Class_Name + "-" + item.SelectedClass.Class_Code,
            BusRoute: item.BusRoute,
            Route_Code: item.Route_Code,
            BusAvailDays: item.BusAvailDays || 0,
            BusMonthlyDays: item.BusMonthlyDays || 0,
            Fee_Posted: item.FeePosted,
            ConcessionAmount: item.ConcessionAmount,
            ReceiveableFee: item.ReceiveableFee,
            ReceivedAmount: item.ReceivedAmount,
            PendingFee: item.PendingFee,
            Challan_No: item.Challan_No || "",
            PaymentStatus: item.PaymentStatus || "",
        }));
    };

    const handleSubmitForCvs = () => {
        setLoaddata(true);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: 1,
            pageSize: 1000000,
            ReportYear: ReportYear,
            ReportMonth: ReportMonth,
            Wing_Id: Number(Wing) || 0,
            Class_Id: Number(Class) || 0,
            Section_Id: Number(Section) || 0,
            AccountLevel: RouteID,
        };

        var api_config = {
            method: "post",
            url: config.base_url + "/Reports/GetRoutesReport",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    if (response.data.totalRecords > 0) {
                        const dataToConvert = {
                            data: buildCsvRows(response.data.ListofRecords),
                            filename: `RoutesReport_${ReportYear}_${ReportMonth}`,
                            delimiter: ",",
                            headers: [
                                "Sr No",
                                "Registration No",
                                "Student Name",
                                "Father Name",
                                "Class",
                                "Bus Route",
                                "Route Code",
                                "Bus Avail Days",
                                "Bus Total Days",
                                "Fee Posted",
                                "Concession",
                                "Receivable",
                                "Received",
                                "Pending",
                                "Challan No",
                                "Payment Status",
                            ],
                        };
                        csvDownload(dataToConvert);
                        setLoaddata(false);
                    } else {
                        toast.error("There is no data available for download", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setLoaddata(false);
                    }
                } else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setLoaddata(false);
                }
            })
            .catch(function (error) {
                toast.error("Network Error..", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLoaddata(false);
            });
    };

    const renderLedger = () => {
        if (listOfLedger != null && listOfLedger.length > 0) {
            return listOfLedger.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{item.Status_Type_Id}</td>
                        <td>{item.Registration_No}</td>
                        <td>{item.Student_Name}</td>
                        <td>{item.Father_Name}</td>
                        <td>{item.SelectedClass.Class_Name} - {item.SelectedClass.Class_Code}</td>
                        <td>{item.BusRoute}</td>
                        <td>{item.Route_Code}</td>
                        <td>{item.BusAvailDays > 0 ? `${item.BusAvailDays}/${item.BusMonthlyDays}` : "—"}</td>
                        <td>{item.FeePosted}</td>
                        <td>{item.ConcessionAmount}</td>
                        <td>{item.ReceiveableFee}</td>
                        <td>{item.ReceivedAmount}</td>
                        <td>{item.PendingFee}</td>
                        <td>{item.Challan_No || "—"}</td>
                        <td>{item.PaymentStatus || "—"}</td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="15">
                        <h4
                            className="mt-3"
                            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
                        >
                            No transport students found for selected filters
                        </h4>
                    </td>
                </tr>
            );
        }
    };

    const printUrl = `/Transport/RoutesPrint?ReportYear=${ReportYear}&ReportMonth=${ReportMonth}&Wing_Id=${Wing || 0}&Class_Id=${Class || 0}&Section_Id=${Section || 0}&RouteID=${RouteID || 0}`;

    return (
        <>
            <TransportMenu />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-8">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/Dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/Transport/TransportDashboard">Transport</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Bus Routes Report
                                    </li>
                                </ol>
                            </nav>
                            <div className="page-title">Bus Routes Report</div>
                            <p className="mb-0" style={{ fontSize: "13px", color: "rgba(0,0,0,0.6)" }}>
                                Students with an assigned bus route ({getMonthName(ReportMonth)} {ReportYear}). Fees shown from posted transport challan ledger.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`collapse ${showFilters ? "show" : ""} `}
                id="collapseFilteres"
            >
                <div className="page-content">
                    <div className="container">
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <div className="card mb-2">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                         <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label className="">
                                                    Select Session:
                                                </label>
                                                <select
                                                    className="form-select"
                                                    name="Session"
                                                    onChange={(e) => {
                                                        setSession(e.target.value);
                                                        setWing(0);
                                                        setClass(0);
                                                        setSection(0);
                                                    }}
                                                >
                                                    <option value="0">---All---</option>
                                                    <SessionsDropDown selectedSession={Session} />
                                                </select>
                                            </div>
                                        </div>
 <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Select Wing:</label>
                                                <select
                                                    name="Wing"
                                                    className="form-select"
                                                    onChange={(e) => {
                                                        setWing(e.target.value)
                                                        setClass(0);
                                                        setSection(0);
                                                    }}
                                                >
                                                    <option value="">---All---</option>
                                                    <WingsDropDown />
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label className="">
                                                    Select Class:
                                                </label>

                                                <select
                                                    className="form-select"
                                                    name="Class"
                                                    onChange={(e) => {
                                                        setClass(e.target.value)
                                                        setSection(0)
                                                    }}
                                                >
                                                    <option value="0">---All---</option>
                                                    {Session != 0 && Wing != 0 && (
                                                        <ClassesDropDown
                                                            SessionID={Session}
                                                            WingID={Wing}
                                                        />
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label className="">
                                                    Select Section:
                                                </label>
                                                <select
                                                    className="form-select"
                                                    name="Section"
                                                    onChange={(e) => setSection(e.target.value)}
                                                >
                                                    <option value="0">---All---</option>
                                                    {Class != 0 && <SectionDropDown ClassID={Class} />}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Select Month:</label>
                                                <select
                                                    className="form-select"
                                                    name="ReportMonth"
                                                    defaultValue={ReportMonth}
                                                    required
                                                >
                                                    <MonthsDropDown />
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label>Select Year:</label>
                                                <select
                                                    className="form-select"
                                                    name="ReportYear"
                                                    defaultValue={ReportYear}
                                                    required
                                                >
                                                    <YearsDropDown />
                                                </select>
                                            </div>
                                        </div>
                                       

                                       
                                        <div className="col-md-3">
                                            <div className="form-group mb-3">
                                                <label className="">
                                                    Select Route:
                                                </label>
                                                <select
                                                    className="form-select"
                                                    name="Route"
                                                    onChange={(e) => setRouteID(e.target.value)}
                                                >
                                                    <option value="0">---All---</option>
                                                    <BusrouteDropDown />
                                                </select>
                                            </div>
                                        </div>
                                        {loaddata ? (
                                            <div className="col-md-2 offset-2 text-center mt-3">
                                                <div>
                                                    <div>
                                                        <Spinner animation="border" role="status"></Spinner>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="col-md-2 offset-2 text-end ">
                                                <div className="form-group text-end mt-4">
                                                    <a
                                                        type="button"
                                                        onClick={handleSubmitForCvs}
                                                        className="print-icon"
                                                    >
                                                        <span>
                                                            <i className="ri-file-excel-2-line"></i>
                                                        </span>
                                                    </a>
                                                </div>
                                            </div>
                                        )}

                                        <div className="col-md-2 text-end">
                                            <div className="form-group text-end">
                                                <button
                                                    type="submit"
                                                    value="Search"
                                                    className="w-100 button button-primary mt-4"
                                                >
                                                    Search
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    <div className="row g-3 mb-3">
                        <div className="col-md-3">
                            <div className="card"><div className="card-body py-2">
                                <small>Transport Students</small>
                                <h5 className="mb-0">{summary.TransportStudents}</h5>
                            </div></div>
                        </div>
                        <div className="col-md-3">
                            <div className="card"><div className="card-body py-2">
                                <small>Fee Posted</small>
                                <h5 className="mb-0">{summary.FeePostedStudents}</h5>
                            </div></div>
                        </div>
                        <div className="col-md-3">
                            <div className="card"><div className="card-body py-2">
                                <small>Collected (Paid)</small>
                                <h5 className="mb-0">{summary.PaidStudents}</h5>
                            </div></div>
                        </div>
                        <div className="col-md-3">
                            <div className="card"><div className="card-body py-2">
                                <small>Receivable Total</small>
                                <h5 className="mb-0">{summary.TotalReceiveableFee}</h5>
                            </div></div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <table className="table table-theme">
                                <thead>
                                    <tr>
                                        <th colSpan={13}>Total Records Found: {totalRecords}</th>
                                        <th colSpan={2} className="text-end">
                                            Pending Total: {summary.TotalPendingFee}
                                        </th>
                                    </tr>
                                </thead>
                                <thead>
                                    <tr>
                                        <th>Sr. No</th>
                                        <th>Registration No</th>
                                        <th>Student Name</th>
                                        <th>Father Name</th>
                                        <th>Class</th>
                                        <th>Bus Route</th>
                                        <th>Route Code</th>
                                        <th>Bus Days</th>
                                        <th>Fee Posted</th>
                                        <th>Concession</th>
                                        <th>Receivable</th>
                                        <th>Received</th>
                                        <th>Pending</th>
                                        <th>Challan No</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td className="text-center" colSpan="15">
                                                <Spinner animation="border" role="status"></Spinner>
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {renderLedger()}
                                            {!loading && listOfLedger.length > 0 && (
                                                <tr>
                                                    <td colSpan={8}><b>Total</b></td>
                                                    <td><b>{summary.TotalPostedFee}</b></td>
                                                    <td><b>{summary.TotalConcessionAmount}</b></td>
                                                    <td><b>{summary.TotalReceiveableFee}</b></td>
                                                    <td><b>{summary.TotalReceivedAmount}</b></td>
                                                    <td><b>{summary.TotalPendingFee}</b></td>
                                                    <td colSpan={2}></td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                            {totalRecords > 10 && (
                                <div className="pagination-wrap">
                                    <div className="row align-items-center">
                                        <div className="col-md-2 form_default">
                                            <div className="d-flex align-items-center">
                                                <label className="me-2" style={{ fontSize: "15px" }}>
                                                    Page Size
                                                </label>
                                                <div className="form-group">
                                                    <select
                                                        className="form-select"
                                                        style={{ width: "100px" }}
                                                        onChange={(e) => {
                                                            setPageNo(1);
                                                            setPageSize(parseInt(e.target.value));
                                                        }}
                                                    >
                                                        <option value="10" selected>
                                                            10
                                                        </option>
                                                        <option value="20">20</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="500">500</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <Pagination
                                            pageNo={pageNo}
                                            pageSize={pageSize}
                                            totalRecords={totalRecords}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="card mt-2">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 text-end">
                                    <NavLink
                                        className="button button-primary"
                                        to={printUrl}
                                        target="_blank"
                                    >
                                        Print Report
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RoutesReport;
